import React from 'react'

const DashedChips = ({text, keyName, className = ''}) => {
  return (
    <div key={keyName} className={`border border-dashed border-primary-color rounded-[10px] px-[10px] py-[5px] flex items-center justify-center capitalize text-[0.68rem] ${className}`}>
        {text}
    </div>
  )
}

export default DashedChips